import { Injectable } from "@angular/core";
import { ZpDataService } from "./zp-data.service";
import { HttpParams } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class AdminDashboardService {
  public users: [];
  constructor(private api: ZpDataService) {}

  getAllUsers() {}

  public async getList(section?, page?, filter?, other?) {
    let params = new HttpParams();

    if (page) {
      console.log("getAllUsers() page - ", page);
      params = params.set("page", page);
    }

    if (section) {
      params = params.set("section", section);
    }

    if (filter) {
      params = params.set("filter", JSON.stringify(filter));
    }

    let result = await this.api.retrieveData("get", "/api/admin/items", params);

    if (result && result.success) {
      if (
        section === "auditlog" ||
        section == "email_config" ||
        (section === "refcodes" && other != "clientAccessPage")
      ) {
        return result;
      } else {
        return result.items;
      }
    } else {
      return [];
    }
  }

  public async putItem(section, item) {
    let result = await this.api.retrieveData("post", "/api/admin/item", {
      section: section,
      item: item,
    });
    return result;
  }
  public async deleteItem(section, item) {
    let result = await this.api.retrieveData("post", "/api/admin/itemDelete", {
      section: section,
      itemId: item._id,
    });
    return result;
  }

  public async retrieveEvents(
    filter,
    eventType = "",
    section = "",
    aggregator = "",
    startDate = "",
    endDate = "",
    limit = 100
  ) {
    let params = new HttpParams();
    if (eventType) {
      params = params.set("event", eventType);
    }
    if (filter) {
      params = params.set("filter", filter);
    }
    if (section) {
      params = params.set("section", section);
    }
    if (aggregator) {
      params = params.set("aggregator", aggregator);
    }
    if (startDate) {
      params = params.set("startDate", startDate);
    }
    if (endDate) {
      params = params.set("endDate", endDate);
    }
    if (limit) {
      params = params.set("limit", "" + limit);
    }
    let result = await this.api.retrieveData("get", "/api/admin/log", params);
    if (result.success) {
      return result.results;
    } else {
      return [];
    }
  }
  public async retrieveEventParams(field) {
    let params = new HttpParams();
    if (field) {
      params = params.set("field", field);
    }
    let result = await this.api.retrieveData(
      "get",
      "/api/admin/logFilters",
      params
    );
    if (result.success) {
      return result.results;
    } else {
      return [];
    }
  }
  public async retrieveDashboardInfo(section, id) {
    let params = new HttpParams();
    if (id) {
      params = new HttpParams().set("id", id);
    }
    if (section) {
      params = params.set("section", section);
    }
    let result = await this.api.retrieveData(
      "get",
      "/api/admin/dashboardInfo",
      params
    );
    if (result && result.success) {
      return result.item;
    } else {
      return undefined;
    }
  }

  public async saveDashboardInfo(section, item) {
    let result = await this.api.retrieveData(
      "post",
      "/api/admin/dashboardInfo",
      { item: item, section: section }
    );
    if (result && result.success) {
      return true;
    } else {
      return false;
    }
  }

  public async deleteDashboardInfo(section, id) {
    let result = await this.api.retrieveData(
      "post",
      "/api/admin/deleteDashboardInfo",
      { id: id, section: section }
    );
    if (result && result.success) {
      return true;
    } else {
      return false;
    }
  }

  public async getAccessRequests() {
    let data = await this.api.retrieveData("get", "/api/admin/accessRequests");
    return data;
  }

  public async unlockPlan(item) {
    let data = await this.api.retrieveData("post", "/api/admin/grantAccess", {
      item: item,
    });
    if (data && data.success) {
      return data;
    }
  }

  public async updateClienteAccessPage(Id, clientAccessPageUrl?) {
    let data = await this.api.retrieveData(
      "post",
      "/api/updateClientAccessPage",
      {
        professionalId: Id,
        clientAccessPageUrl: clientAccessPageUrl,
      }
    );
    if (data && data.success) {
      return data;
    }
  }

  public async getPotentialDelegates() {
    let data = await this.api.retrieveData(
      "get",
      "/api/admin/potentialDelegates"
    );
    return data;
  }

  public async getPlanHoldersAccountsFromMfa(refCode) {
    console.log("refCode", refCode);
    let data = await this.api.retrieveData(
      "get",
      `/api/admin/countUsersPerRefcode/${refCode}`
    );
    console.log("data", data);
    if (data.success) {
      return data.userCount;
    } else {
      console.log('Error with the API.')
    }
  }
}
